"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var od_icon_1 = __importDefault(require("@tencent/od-icon"));
var classnames_1 = __importDefault(require("classnames"));
function SidebarItem(props) {
  var iconClassName = props.iconClassName,
    className = props.className,
    label = props.label,
    href = props.href,
    hide = props.hide,
    active = props.active,
    disable = props.disable,
    _a = props.type,
    type = _a === void 0 ? 'first-level' : _a,
    onClick = props.onClick,
    icon = props.icon,
    LinkComponent = props.LinkComponent;
  var getIcon = (0, react_1.useMemo)(function () {
    switch (type) {
      case 'undone':
        return (
          // 未完成
          react_1["default"].createElement("div", {
            className: "odc-sidebar-item-icon icon-undone"
          })
        );
      case 'done':
        return (
          // 完成
          react_1["default"].createElement(od_icon_1["default"], {
            className: "odc-sidebar-item-icon icon-done",
            name: "check-filled"
          })
        );
      case 'error':
        return (
          // 异常
          react_1["default"].createElement(od_icon_1["default"], {
            className: "odc-sidebar-item-icon",
            name: "exclamation-filled",
            color: "var(--od-red-06)"
          })
        );
      default:
        return icon ? icon : iconClassName && react_1["default"].createElement("div", {
          className: "".concat(iconClassName, " odc-sidebar-item-icon")
        });
    }
  }, [icon, iconClassName, type]);
  if (hide) return null;
  var ele = react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-sidebar-item', className, type, {
      disable: disable,
      active: active
    }),
    onClick: onClick
  }, getIcon, react_1["default"].createElement("div", {
    className: "odc-sidebar-item-label"
  }, label));
  if (href) {
    if (LinkComponent) {
      return LinkComponent === null || LinkComponent === void 0 ? void 0 : LinkComponent({
        className: 'odc-sidebar-a',
        href: href,
        children: ele,
        onClick: onClick,
        itemProps: props
      });
    }
    return react_1["default"].createElement("a", {
      className: "odc-sidebar-a",
      href: href
    }, ele);
  }
  return ele;
}
exports["default"] = SidebarItem;